export default __webpack_public_path__ + "static/media/food_house-24px.a0019a30.svg";